export interface McpWidgetComposeParameters {
    readonly draftId: string;
    readonly routeKey?: string;
}

export type McpWidgetComposeHandler = (parameters: McpWidgetComposeParameters) => void;

let registeredHandler: McpWidgetComposeHandler | undefined;

export function registerMcpWidgetComposeHandler(handler: McpWidgetComposeHandler): () => void {
    registeredHandler = handler;
    return () => {
        if (registeredHandler === handler) {
            registeredHandler = undefined;
        }
    };
}

export function dispatchMcpWidgetCompose(parameters: McpWidgetComposeParameters): void {
    registeredHandler?.(parameters);
}
